import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'movable-action',
    templateUrl:'movableAction.html'
})
export class MovableActionComponent extends BaseActionComponent{

  public itens;
  public linkForm: FormGroup;
  public level=1;
  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
    this.linkForm = this.fb.group({
      xEnd:0,
      yEnd:0,
      zEnd:0,
      rxEnd:0,
      ryEnd:0,
      rzEnd:0,
      sxEnd:0,
      syEnd:0,
      szEnd:0,
      distance:2
    });

  }
  public setMinAxis(){
    if (this._appData.action.param.minRot){
      delete this._appData.action.param.minRot
      return;
    }
    let varr
    if (this._appData.action.param.staticRotate=='X'){
      varr=this._appData.object.rotation.x
    }
    if (this._appData.action.param.staticRotate=='Y'){
      varr=this._appData.object.rotation.y
    }
    if (this._appData.action.param.staticRotate=='Z'){
      varr=this._appData.object.rotation.z
    }
      this._appData.action.param.minRot=varr;
  }

  public setMaxAxis(){
    if (this._appData.action.param.maxRot){
      delete this._appData.action.param.maxRot
      return;
    }
    let varr
    if (this._appData.action.param.staticRotate=='X'){
      varr=this._appData.object.rotation.x
    }
    if (this._appData.action.param.staticRotate=='Y'){
      varr=this._appData.object.rotation.y
    }
    if (this._appData.action.param.staticRotate=='Z'){
      varr=this._appData.object.rotation.z
    }
      this._appData.action.param.maxRot=varr;
  }
  public selectItem(it) {
    for (let i = 0; i < this.itens.length; i++) {
      if (this.itens[i].objectId == it.objectId) {
        this.itens[i].selected= this.itens[i].selected ? false : true 
      }
    }
  }  
  public setAxis(varr){
    if (!this._appData.action){
      this._appData.action={kind:'movable',param:{}}
    }
    if (varr){
      this._appData.action.param.staticRotate=varr;
    }
    else{
      delete this._appData.action.param.staticRotate

    }
  }
  public processData(action){
    if (!action){
      this._appData.action={kind:'movable',param:{}}
    }
    if (!action.param){
      this._appData.action.param={end:{},itens:[]};
    }
    action.param.end = this.linkForm['_value'];
    let itemArray=[]
    
    this.itens.forEach(it=>{
      if (it.selected){
        itemArray.push(it.objectId)
      }
    })
    action.param.itens=itemArray    
  }
  public whereIAm(option){
    let linkParam = this.linkForm['_value'];

      linkParam.xEnd=this._appData.object.position.x
      linkParam.yEnd=this._appData.object.position.y
      linkParam.zEnd=this._appData.object.position.z
      linkParam.rxEnd=this._appData.object.rotation.x
      linkParam.ryEnd=this._appData.object.rotation.y
      linkParam.rzEnd=this._appData.object.rotation.z
      linkParam.sxEnd=this._appData.object.scale.x
      linkParam.syEnd=this._appData.object.scale.y
      linkParam.szEnd=this._appData.object.scale.z

    this.linkForm = this.fb.group(linkParam);
  }
  public removeEnd(){
    let linkParam = this.linkForm['_value'];

      linkParam.xEnd=this._appData.object.position.x
      linkParam.yEnd=this._appData.object.position.y
      linkParam.zEnd=this._appData.object.position.z
      linkParam.rxEnd=this._appData.object.rotation.x
      linkParam.ryEnd=this._appData.object.rotation.y
      linkParam.rzEnd=this._appData.object.rotation.z
      linkParam.sxEnd=this._appData.object.scale.x
      linkParam.syEnd=this._appData.object.scale.y
      linkParam.szEnd=this._appData.object.scale.z

    this.linkForm = this.fb.group(linkParam);
  }
  public childrenReloadData(){
    let action = this._appData.action;
    if (action.param.end) {
      this.linkForm = this.fb.group(action.param.end);
    }    
    this.itens=[]
    if (!this.roomProcessing){
      this._companyService.getUserRoomItemRef(this._appData.room.id).get().then(its=>{
        its.forEach(it=>{
          let item=it.data();
          item.selected=false;
          if (action.param.itens){
            action.param.itens.forEach(sit=>{
              if (sit==item.objectId){
                item.selected=true;
              }
            })
          }
          this.itens.push(item)
        })
        this.roomProcessing=false;
      })  
    this.roomProcessing=true;

    }  
  }
  public roomProcessing=false;
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/movableAction.ts